import React from 'react';

import { cn } from 'utils/cn';

import styles from './styles.module.css';

interface TextProps {
	/**
	 * The content to be displayed inside the Text component.
	 */
	children: React.ReactNode | React.JSX.Element;

	/**
	 * The alignment of the text: 'left', 'center', or 'right'.
	 * @default 'left'
	 */
	align?: 'left' | 'center' | 'right';

	/**
	 * Whether the text should be displayed as a heading.
	 * @default false
	 */
	heading?: boolean;

	/**
	 * Additional class names to apply to the container.
	 */
	className?: string;
}

function Text({ align = 'left', className, heading, ...props }: TextProps) {
	const gap = heading ? '.75rem' : '1.5rem';

	return (
		<div
			className={cn(styles.container, className)}
			data-align={align}
			style={{ gap }}
		>
			{props.children}
		</div>
	);
}

export default Text;
